import type { WorkspaceDefinition } from '@/core/ui/workspace'

// docs/upgrade/06 §4 nhóm CRM (đợt M3).
const organizations = () => import('@/modules/organizations/OrganizationsView.vue')

export const customersWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'list', labelKey: 'nav.customers', icon: 'pi pi-building', permission: 'Customers.Read', component: () => import('@/modules/customers/CustomersView.vue') },
    { key: 'interactions', labelKey: 'customerInteractions.title', icon: 'pi pi-comments', permission: ['Customers.Read', 'CustomerInteractions.Read'], permissionMode: 'all',
      component: () => import('@/modules/customers/CustomerInteractionsView.vue') },
  ],
}

export const organizationsWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'partners', labelKey: 'nav.partners', icon: 'pi pi-sitemap', permission: 'Customers.Read', component: organizations, props: { kind: 'Partner' } },
    { key: 'suppliers', labelKey: 'nav.suppliers', icon: 'pi pi-truck', permission: 'Customers.Read', component: organizations, props: { kind: 'Supplier' } },
  ],
}

export const salesDocumentsWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'quotations', labelKey: 'nav.quotations', icon: 'pi pi-calculator', permission: 'Projects.Read', component: () => import('@/modules/quotations/QuotationsView.vue') },
    // ADR-074: PO khách hàng (khách đặt hàng công ty) — khác «Đơn đặt hàng NCC» ở Mua hàng; quyền đọc như hợp đồng (ProjectContractsRead).
    { key: 'customer-orders', labelKey: 'nav.customerOrders', icon: 'pi pi-inbox', permission: ['ProjectContracts.Read', 'WarrantyTickets.Read', 'Projects.Read'], permissionMode: 'any',
      component: () => import('@/modules/customerOrders/CustomerOrdersView.vue') },
    { key: 'contracts', labelKey: 'nav.projectContracts', icon: 'pi pi-file-check', permission: ['ProjectContracts.Read', 'WarrantyTickets.Read', 'Projects.Read'], permissionMode: 'any',
      component: () => import('@/modules/projects/ProjectContractsView.vue') },
  ],
}

// ADR-076: mẫu chứng từ — mỗi loại một tab, cùng một màn quản lý.
const documentTemplates = () => import('@/modules/documentTemplates/DocumentTemplatesView.vue')
export const documentTemplatesWorkspace: WorkspaceDefinition = {
  tabs: [
    { key: 'quotation', labelKey: 'documentTemplates.categories.quotation', icon: 'pi pi-calculator', permission: 'DocumentTemplates.Read', component: documentTemplates, props: { category: 'quotation' } },
    { key: 'contract', labelKey: 'documentTemplates.categories.contract', icon: 'pi pi-file-word', permission: 'DocumentTemplates.Read', component: documentTemplates, props: { category: 'contract' } },
    { key: 'rfq', labelKey: 'documentTemplates.categories.rfq', icon: 'pi pi-send', permission: 'DocumentTemplates.Read', component: documentTemplates, props: { category: 'rfq' } },
    { key: 'purchase-order', labelKey: 'documentTemplates.categories.purchase-order', icon: 'pi pi-truck', permission: 'DocumentTemplates.Read', component: documentTemplates, props: { category: 'purchase-order' } },
  ],
}
